import React from "react";
import { Box, Card, CardActionArea, Typography, Button } from "@mui/material";
import { IMAGE_BASE_URL } from "../utils/constants";
import { formatPrice, stripHtml } from "../utils/helpers";

export default function ProductCard({ product, currency, onPress }) {
  const price = product.offer_price ?? product.price;
  const hasOffer = product.offer_price && Number(product.offer_price) < Number(product.price);
  const imgSrc = product.cover_image
    ? `${IMAGE_BASE_URL}media/${product.store_id}/product/card/${product.cover_image}`
    : null;
  const description = stripHtml(product.description);

  return (
    <Card variant="outlined" sx={{ display: "flex", alignItems: "center", p: 1, mb: 1.25, borderRadius: 2, overflow: "hidden" }}>
      {/* minWidth:0 is what makes the name's ellipsis work: a flex item
          defaults to min-width:auto, so without it this area refuses to shrink
          below the full width of a long product name and pushes the Add button
          off the card instead of truncating. */}
      <CardActionArea
        onClick={() => onPress(product)}
        sx={{ display: "flex", alignItems: "center", gap: 1.5, borderRadius: 2, flex: 1, minWidth: 0 }}
      >
        <Box
          component={imgSrc ? "img" : "div"}
          src={imgSrc || undefined}
          sx={{ width: 64, height: 64, borderRadius: 1.5, objectFit: "cover", bgcolor: "grey.100", flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, minWidth: 0, py: 0.5 }}>
          <Typography variant="subtitle2" fontWeight={700} noWrap>
            {product.name}
          </Typography>
          {description && (
            <Typography variant="caption" color="text.secondary" sx={{ display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
              {description}
            </Typography>
          )}
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mt: 0.5 }}>
            <Typography variant="subtitle2" fontWeight={700} color="primary.main">
              {formatPrice(price, currency)}
            </Typography>
            {hasOffer && (
              <Typography variant="caption" color="text.disabled" sx={{ textDecoration: "line-through" }}>
                {formatPrice(product.price, currency)}
              </Typography>
            )}
          </Box>
        </Box>
      </CardActionArea>
      {/* flexShrink:0 keeps the button at a fixed width in every row, so it
          stays aligned down the list regardless of how long the name is. */}
      <Button
        size="small"
        variant="outlined"
        onClick={() => onPress(product)}
        sx={{ minWidth: 64, ml: 1, flexShrink: 0 }}
      >
        Add
      </Button>
    </Card>
  );
}
